import Navbar from './components/Navbar';
import {Route, Switch} from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Experience from './pages/Experience';
import BeHappy from './pages/BeHappy';
import RecentWorks from './pages/RecentWorks';
import Contact from './pages/Contact';
import ErrorPage from './pages/ErrorPage';
import ProjectPage from './pages/ProjectPage';
import {Helmet} from "react-helmet";

function App() {
  return (
    <div className="App">
       <Helmet>
          <meta charSet="utf-8" />
          <title>Mostafa Abdelazeem - Homepage</title>
          <link rel="canonical" href="https://moabdo.netlify.app/" />
          <meta name="description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive"></meta>
          <meta name="robots" content="index, follow"/>
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Mostafa Abdelazeem" />
          <meta property="og:description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive" />
          <meta property="og:image" content="http://moabdo.netlify.app/static/media/hero.5c32137d.jpg" />
          <meta property="og:url" content="https://moabdo.netlify.app/" />
          <meta property="og:site_name" content="Mostafa Abdelazeem - Portfolio" />
        </Helmet>
      <Navbar/>
      <>
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route exact path='/about' component={About}/>
          <Route exact path='/experience' component={Experience}/>
          <Route exact path='/beHappy' component={BeHappy}/>
          <Route exact path='/recentWorks' component={RecentWorks}/>
          <Route exact path='/projects/:slug' component={ProjectPage}/>
          {/* <Route exact path='/services' component={Services}/> */}
          <Route exact path='/contact' component={Contact}/>
          <Route component={ErrorPage}/>
        </Switch>
      </>
    </div>
  );
}

export default App;
